import { ConfirmationData } from "../../../../common/summary-common/confirmationData";


export const overWritePoliticallyExposedPersonInformation: Map<string, ConfirmationData> = new Map([
    ["a6492af1-7ecb-43d2-8b4e-de19410291b4", { hidden: true }],
    ["1e2256ee-aa56-4a1f-b6d4-bb35668179c0|e1b20b24-9aeb-49cd-9288-adb444a17f71", { hidden: true }],
]);



